import styled from "styled-components";

export const Styled = styled.div`
  position: absolute;
  height: 50px;
  width: 100%;
  text-align: center;

  button {
    width: 100px;
    height: 30px;
    background-color: #b0b0b0;
    border: 2px solid black;
    border-radius: 15px;
    font-weight: bold;
    font-size: 18px;
    margin: 20px;
  }

  button:hover {
    background-color: #779556;
  }

  @media (max-width: 767px) {
    position: relative;
    margin-bottom: 75px;
  }
`;
